import script from "./imagemInput.vue?vue&type=script&setup=true&lang=js"
export * from "./imagemInput.vue?vue&type=script&setup=true&lang=js"

import "./imagemInput.vue?vue&type=style&index=0&id=e2be6266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2be6266"]])

export default __exports__